import { createAction, props } from '@ngrx/store';
import { iUsuario } from '../../usuario/usuario.interface';

export const cargaUsuario = createAction('[Usuario Component] cargaUsuario', props<{ oUsuario: iUsuario }>());
export const resetUsuario = createAction('[Usuario Component] resetUsuario');
